// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "NextPrevious-module--cds--assistive-text--5d785";
export var cdsVisuallyHidden = "NextPrevious-module--cds--visually-hidden--3855d";
export var direction = "NextPrevious-module--direction--f3d1a";
export var grid = "NextPrevious-module--grid--1aa65";
export var hideFeedback = "NextPrevious-module--hide-feedback--57909";
export var isHomepage = "NextPrevious-module--isHomepage--18461";
export var link = "NextPrevious-module--link--806bd";
export var linkContainer = "NextPrevious-module--link-container--027e3";
export var name = "NextPrevious-module--name--ed4ef";
export var showFeedback = "NextPrevious-module--show-feedback--eb304";
export var skeleton = "NextPrevious-module--skeleton--e42fe";
export var wrapper = "NextPrevious-module--wrapper--8eb21";